import React from 'react';

export const SplashScreen: React.FC = () => {
    return (
        <div className="fixed inset-0 bg-brand-cream flex flex-col items-center justify-center z-[100]">
            <style>{`
                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                @keyframes popIn { 
                    0% { opacity: 0; transform: scale(0.8); }
                    100% { opacity: 1; transform: scale(1); }
                }
                .animate-fadeIn { animation: fadeIn 1s ease-out forwards; }
                .animate-popIn { animation: popIn 0.8s cubic-bezier(0.68, -0.55, 0.27, 1.55) forwards; animation-delay: 0.2s; }
            `}</style>
             <div className="flex items-center gap-4 animate-popIn opacity-0">
                <img 
                    src="/aj-logo.jpg" 
                    alt="AJ STUDIOZ Logo" 
                    className="w-20 h-20 rounded-2xl object-cover shadow-2xl"
                />
                <span className="text-5xl font-extrabold tracking-tighter bg-gradient-to-r from-brand-coral via-purple-600 to-brand-coral bg-clip-text text-transparent">
                    AJ STUDIOZ
                </span>
            </div>
            <p className="mt-4 text-brand-charcoal/70 animate-fadeIn opacity-0" style={{animationDelay: '0.8s'}}>
                Your AI-Powered Creative Suite
            </p>
        </div>
    );
};
